export default [
	{
		path: 'delivery',
		name: 'erp_delivery',
		component: () => import('@/pages/erp/delivery_list')
	},
	{
		path: 'order',
		name: 'erp_offline_order',
		component: () => import('@/pages/erp/offline_order_list')
	},
	{
		path: 'aftersales',
		name: 'erp_offline_aftersales_order',
		component: () => import('@/pages/erp/offline_aftersale_list')
	},
	{
		path: 'onlineOrder',
		name: 'erp_online_order',
		component: () => import('@/pages/erp/online_order_list')
	},
	{
		path: 'onlineAftersales',
		name: 'erp_online_aftersales_order',
		component: () => import('@/pages/erp/online_aftersale_list')
	}
];
